import { render, staticRenderFns } from "./SendNewsEditor.vue?vue&type=template&id=f6bd3e2a"
import script from "./SendNewsEditor.vue?vue&type=script&lang=js"
export * from "./SendNewsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports